<div class="container py-4">
  <h2>Carrito</h2>

  <div *ngIf="!cart.items().length" class="alert alert-info mt-3">
    Tu carrito está vacío.
  </div>

  <div class="list-group my-3" *ngIf="cart.items().length">
    <div class="list-group-item d-flex align-items-center justify-content-between"
         *ngFor="let it of cart.items()">
      <div class="d-flex align-items-center gap-3">
        <img [src]="it.product.images[0]" width="56" height="56" class="rounded" alt="">
        <div>
          <div class="fw-medium">{{ it.product.name }}</div>
          <small class="text-secondary">
            {{ it.product.price | currency:'PEN':'symbol-narrow' }}
          </small>
        </div>
      </div>

      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-sm btn-outline-secondary" (click)="cart.setQty(it.product.id, it.qty-1)">-</button>
        <input class="form-control form-control-sm text-center" style="width:72px"
               [value]="it.qty"
               (input)="cart.setQty(it.product.id, +($any($event.target).value || 1))">
        <button class="btn btn-sm btn-outline-secondary" (click)="cart.setQty(it.product.id, it.qty+1)">+</button>
        <button class="btn btn-sm btn-outline-danger" (click)="cart.remove(it.product.id)">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-between" *ngIf="cart.items().length">
    <h5>Total: {{ cart.total() | currency:'PEN':'symbol-narrow' }}</h5>
    <a class="btn btn-success" routerLink="/checkout">Continuar</a>
  </div>
</div>
